export default {
  route: {
    shareRevoked: '擁有者已停止分享此連結。',
    invalidUrl: '此網址並未指向有效的專案。',
    notFound: '此幾何不存在，或您沒有存取權限。',
  },
  dashboard: {
    columnName: '名稱',
    columnStatus: '狀態',
    columnCreated: '建立時間',
    columnCompleted: '完成時間',
    columnUpdated: '更新時間',
    columnActions: '操作',
    saveName: '儲存名稱',
    cancel: '取消',
    uploadTitle: '拖入 CAD 檔案以建立網格',
    uploadSubtitle: 'STEP、STP、OBJ 或 STL — 最大 1 GB',
    controlsTitle: '網格',
    countLabel_one: '{{count}} 個網格',
    countLabel_other: '{{count}} 個網格',
    searchPlaceholder: '搜尋網格…',
    typeFilter: '類型',
    tagFilter: '標籤',
    typeFea: 'FEA',
    typeCfd: 'CFD',
    typeCht: 'CHT',
    tagCfdExt: 'CFD · 外部',
    tagCfdInt: 'CFD · 內部',
    tagCht: 'CHT',
    tagFea: 'FEA',
    tagWrap: 'Wrap',
    tagRepair: 'Repair',
    tagTet: 'Tet',
    tagHex: 'Hex',
    tagPoly: 'Poly',
    noTypes: '沒有類型',
    noTags: '沒有標籤',
    clearFilter: '清除篩選',
    tabAll: '全部',
    tabMeshing: '網格化中',
    tabDone: '完成',
    tabFailed: '失敗',
    emptyTitleNone: '尚無網格',
    emptyTitleFiltered: '沒有符合篩選條件的網格',
    emptyHintNone: '在上方上傳 CAD 檔案以開始建立網格。',
    emptyHintSearchMore:
      '已載入的網格中沒有符合項目 — 請捲動以載入更多，或改用其他搜尋。',
    emptyHintFiltered: '請嘗試其他篩選條件或搜尋關鍵字。',
    loadingLabel: '正在載入網格…',
    tableEmpty: '尚無可用的網格。',
  },
  rowActions: {
    publicTooltip: '公開 — 任何取得連結的人都可檢視',
    privateTooltip: '私人 — 僅您的團隊可見',
    public: '公開',
    private: '私人',
    downloadReady: '下載網格結果',
    downloadDisabled: '僅在狀態為「完成」時才能下載',
    downloadMeshResult: '下載網格結果',
    chooseFormat: '選擇下載格式',
    downloadFormatMenu: '下載格式',
    moreActions: '更多操作',
    actionsMenu: '幾何操作',
    makePrivate: '設為私人',
    makePublic: '設為公開',
    copyPublicLink: '複製公開連結',
    rename: '重新命名',
    delete: '刪除',
  },
  status: {
    processing: '處理中',
    error: '診斷錯誤',
    noMesh: '無網格',
    meshing: '網格化中',
    done: '完成',
    failed: '失敗',
  },
  deleteDialog: {
    title: '要刪除此幾何嗎？',
    descriptionSuffix: '以及由其產生的網格將被永久移除。此操作無法復原。',
    cancel: '取消',
    confirm: '刪除幾何',
  },
  sidebar: {
    renameTooltip: '點擊以重新命名專案',
  },
  rename: {
    notAvailable: '尚無法重新命名 — 即將推出。',
    failed: '無法重新命名 — 請再試一次。',
  },
  viewer: {
    loading: '正在載入檢視器…',
  },
  workspace: {
    backToLibrary: '返回網格列表',
  },
  restore: {
    title: '正在還原工作階段',
    subtitle: '正在載入您先前的工作…',
    skip: '略過 — 重新開始',
  },
  tree: {
    filesHeader: '檔案',
    modeLatest: '最新',
    modeAll: '全部',
    containerLabel: 'MeshGen 幾何樹',
    mesh: '網格',
    refinement: '細化',
    aiRetry: 'AI 重試',
    originRepaired: '自動修復的幾何',
    originManualRepaired: '修復的幾何',
    originUploaded: '使用者上傳的幾何',
    // 版本樹上「簡化候選」的短標籤. 完整說明放在 tooltip 中 — 使用者
    // 常對「候選」二字沒有明確語感, 需說明這是「等待你核准的簡化提案」.
    originSimplified: '簡化候選',
    originRepairedTooltip:
      '此版本是由前一版 CAD 自動修復而來的。非流形邊、破洞與問題面已修正, 拓撲結構仍與原始版本相同。',
    originManualRepairedTooltip:
      '此版本是依修復要求由前一版 CAD 修復而來的。非流形邊、破洞與問題面已修正, 拓撲結構仍與原始版本相同。',
    originUploadedTooltip:
      '此版本是你上傳的 CAD 檔案。可在檢視器中檢視, 或於列的選單中下載。',
    originSimplifiedTooltip:
      '此版本是應用程式提出的 CAD 簡化提案 — 透過將多個冗餘實體聯集為單一本體達成。這是一個「候選」 — 除此之外沒有其他變更, 且只有在你核准後才會成為使用中的幾何。若拒絕則保留原本的版本。',
    expand: '展開',
    collapse: '收合',
    previewAsCad: '以 CAD 鑲嵌預覽',
    previewCadActive: '正在顯示 CAD 鑲嵌 — 點選以切換為自動預覽',
    downloadSourceFile: '下載原始檔案',
    downloadMesh: '下載網格',
    directionInternal: '內部',
    directionExternal: '外部',
    meshStatusLabel: '網格狀態：{{status}}',
    noSourceFile: '此版本沒有可下載的原始檔案。',
    downloadSourceFailed: '無法下載原始檔案 — 請再試一次。',
  },
  meshControls: {
    resultsTitle: '網格結果',
    startStudy: '開始 SimOps 研究',
  },
  upload: {
    uploading: '正在上傳新版本…',
    uploaded: '已上傳新版本 — 正在執行新的 Diagnosis',
    failed: '上傳失敗 — 請再試一次',
  },
} as const;
